import { useDataStore } from "@/stores";
import { FormControl, InputLabel, MenuItem, OutlinedInput, Select, SelectChangeEvent } from "@mui/material";
import { useMemo } from "react";

type DisciplinesDropdownProps = {
    selectedVersions: string[];
    loading: boolean;
    value: Array<string>;
    onChange: (event: SelectChangeEvent<Array<string>>) => void;
};

const DownloadDisciplinesDropdown = ({ selectedVersions, value, loading, onChange }: DisciplinesDropdownProps) => {
    const disciplines = useDataStore((state) => state.disciplines);

    const items = useMemo(() => {
        const commonDisciplines = selectedVersions.length
            ? [
                  ...selectedVersions
                      .map((versionId) => disciplines[versionId] || [])
                      .reduce((a, b) => a.filter((c) => b.some((d) => d.id === c.id))),
              ]
            : [];
        return commonDisciplines;

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedVersions, loading, disciplines]);

    return (
        <FormControl fullWidth size={"medium"} id={"medium"}>
            <InputLabel id="disciplines-dropdown-label">Discipline(s)</InputLabel>
            <Select
                labelId="disciplines-dropdown-label"
                id="disciplines-dropdown"
                multiple
                value={value}
                onChange={onChange}
                input={<OutlinedInput label={"Discipline(s)"} />}
                MenuProps={{
                    PaperProps: {
                        style: {
                            maxHeight: 48 * 4.5 + 8,
                        },
                    },
                }}
                fullWidth
            >
                {loading ? (
                    <MenuItem value={""}>Loading...</MenuItem>
                ) : (
                    items
                        .sort((a, b) => b.order - a.order)
                        .map((x) => (
                            <MenuItem key={x.id} value={x.id}>
                                {x.label}
                            </MenuItem>
                        ))
                )}
            </Select>
        </FormControl>
    );
};

export default DownloadDisciplinesDropdown;
